import React from 'react'
import { BrowserSearchField } from 'storfox-query-builder'

import * as API from '~/constants/api'

function DeliveryMethodField ({ ...props }) {
  return (
    <BrowserSearchField
      api={API.DELIVERY_METHOD_LIST}
      {...props}
    />
  )
}

export default DeliveryMethodField
